import { Injectable } from '@angular/core';
import { IBrandingStyleResponse } from '../api/dashboard/branding-service/branding-model';
import { BehaviorSubject } from 'rxjs';
import { IAdvancedTemplateModel } from '../api/dashboard/advanced-templates-service/advanced-templates.model';

@Injectable({providedIn: 'root'})
export class StyleService {

    public brandingStyle: IBrandingStyleResponse;

    private brandingStyleSubject = new BehaviorSubject<IBrandingStyleResponse>(null);
    public brandingStyle$ = this.brandingStyleSubject.asObservable();

    public setStyleInputElements(advancedTemplate: IAdvancedTemplateModel) {
        const docStyle = document.documentElement.style;
        docStyle.setProperty('--body-background-color', advancedTemplate.contentSetting.contentBlockSetting.backgroundColor);
        docStyle.setProperty('--content-text-color', advancedTemplate.contentSetting.contentBlockSetting.textColor);
        docStyle.setProperty('--content-color', advancedTemplate.contentColor);
        docStyle.setProperty('--button-background-color', advancedTemplate.buttonSetting.buttonFullSetting.buttonColor.regularBackgroundColor);
        docStyle.setProperty('--button-text-color', advancedTemplate.buttonSetting.buttonFullSetting.buttonColor.regularTextColor);
    }

    public loadCustomFont(name: string, url: string) {
        const customFont = new FontFace(name, 'url(' + url + ')');
        customFont.load().then((f) => {
            document.fonts.add(f);
        },
        (err) => {
            console.error(err);
        });
    }

    public setBrandingStyle(brandingStyle: IBrandingStyleResponse) {
        this.brandingStyleSubject.next(brandingStyle);
        this.brandingStyle = brandingStyle;
    }

    public getFullButtonStyle(advancedTemplate: IAdvancedTemplateModel): Record<string, string> {
        return {
            '--full-button-regular-background-color': advancedTemplate.buttonSetting.buttonFullSetting.buttonColor.regularBackgroundColor,
            '--full-button-regular-color': advancedTemplate.buttonSetting.buttonFullSetting.buttonColor.regularTextColor,
            '--full-button-regular-border-color': advancedTemplate.buttonSetting.buttonFullSetting.buttonColor.regularBorderColor,
            '--full-button-hover-background-color': advancedTemplate.buttonSetting.buttonFullSetting.buttonColor.hoverBackgroundColor,
            '--full-button-hover-color': advancedTemplate.buttonSetting.buttonFullSetting.buttonColor.hoverTextColor,
            '--full-button-hover-border-color': advancedTemplate.buttonSetting.buttonFullSetting.buttonColor.hoverBorderColor,
            '--full-button-font-family': advancedTemplate.buttonSetting.fontFamily
        };
    }

    public getHollowButtonStyle(advancedTemplate: IAdvancedTemplateModel): Record<string, string> {
        return {
            '--hollow-button-regular-background-color': advancedTemplate.buttonSetting.buttonHollowSetting.buttonColor.regularBackgroundColor,
            '--hollow-button-regular-color': advancedTemplate.buttonSetting.buttonHollowSetting.buttonColor.regularTextColor,
            '--hollow-button-regular-border-color': advancedTemplate.buttonSetting.buttonHollowSetting.buttonColor.regularBorderColor,
            '--hollow-button-hover-background-color': advancedTemplate.buttonSetting.buttonHollowSetting.buttonColor.hoverBackgroundColor,
            '--hollow-button-hover-color': advancedTemplate.buttonSetting.buttonHollowSetting.buttonColor.hoverTextColor,
            '--hollow-button-hover-border-color': advancedTemplate.buttonSetting.buttonHollowSetting.buttonColor.hoverBorderColor,
            '--hollow-button-font-family': advancedTemplate.buttonSetting.fontFamily
        };
    }

}
